<template lang="pug">
div
    div.box
        v-server-table(
            :url="datatable.api"
            :name="datatable.name"
            :columns="datatable.columns"
            :options="datatable.options"
            ref="datatable"
        )

    subsidy-form(ref="subsidy-form" @refresh-table="refresh")
</template>

<script>
import Auth from '@js/plugins/auth';
import SubsidyForm from './form.vue';

const TableName = 'VUETABLE_SUBSIDY';

export default {
    components: { SubsidyForm },

    data() {
        let canManageSubsidys = Auth.hasPermissionTo(
            'franchise_manage_subsidy',
        );

        let actionButtons = [
            {
                title: 'Create Subsidy',
                action: () => this.displayForm(null),
            },
        ];

        if (!canManageSubsidys) {
            actionButtons = [];
        }

        return {
            datatable: {
                api: Laroute.route('franchise.setting.subsidy.list'),
                name: TableName,
                columns: ['name', 'type', 'grades', 'outlets'],
                options: {
                    checkbox: canManageSubsidys,
                    sortable: ['name'],
                    orderBy: {
                        column: 'name',
                        ascending: 1,
                    },
                    customFilters: [],
                    initFilters: {
                        outlets: [],
                        types: [],
                    },
                    actionButtons: actionButtons,
                    rowClassCallback: row => 'pointer',
                    rowClickCallback: this.displayForm,
                    templates: {
                        grades(h, row) {
                            return require('./templates/grades.jsx')(h, row);
                        },

                        outlets(h, row) {
                            let outlets = this.trans(
                                'general.outlets',
                            ).toLowerCase();

                            return require('./templates/outlets.jsx')(
                                h,
                                row,
                                outlets,
                            );
                        },
                    },
                    headings: {
                        grades: 'Fuel Grade',
                    },
                },
            },
        };
    },

    computed: {},

    watch: {},

    methods: {
        refresh() {
            this.$refs.datatable.getData();
        },
        displayForm(data) {
            this.$bus.$emit('manage_subsidy::display_form', data);
        },
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/franchise_component/setting/subsidy/datatable.vue